var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch__container"},[_c('input',{ref:"switchButton",staticClass:"switch switch--shadow",attrs:{"id":_vm.switchId,"type":"checkbox"},domProps:{"value":_vm.switchValue}}),_c('label',{attrs:{"for":_vm.switchId,"id":_vm.switchId},on:{"click":_vm.changeSwitchValue}})])
}
var staticRenderFns = []

export { render, staticRenderFns }